import FutureSightLanding from './FutureSightLanding';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

FutureSightLanding.schema = schema;
FutureSightLanding.defaultProps = getEmptyDefaultProps(schema.templateSettings);

// https://github.com/webpack/webpack/issues/706
export default FutureSightLanding;
